<template>
    <div class="waba-supsis-volume-based-pricing-tier-update">
        <div class="title">Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendi</div>
        <div class="meta">
            <div><b>Event</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>Kanal ID</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>Tier</b>: {{ $_.get(activity, "payload.volume_tier_info.tier") }}</div>
            <div><b>Fiyatlandırma Kategorisi</b>: {{ $_.get(activity, "payload.volume_tier_info.pricing_category") }}</div>
            <div><b>Geçerli Ay</b>: {{ $_.get(activity, "payload.volume_tier_info.effective_month") }}</div>
            <div><b>Bölge</b>: {{ $_.get(activity, "payload.volume_tier_info.region") }}</div>
            <div v-if="$_.get(activity, 'payload.volume_tier_info.tier_update_time')">
                <b>Güncelleme Zamanı</b>: {{ formatTime($_.get(activity, "payload.volume_tier_info.tier_update_time")) }}
            </div>
        </div>
        <details class="raw">
            <summary>Ham payload</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisVolumeBasedPricingTierUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
    methods: {
        formatTime(timestamp) {
            if (!timestamp) return "";
            const date = new Date(timestamp * 1000);
            return date.toLocaleString("tr-TR");
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-volume-based-pricing-tier-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
